import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AttachService, DeliveryService, DispatchService, DraftCollectionService, MessageService } from 'orv-ui-base-lib';


@Component({
	selector: 'app-attachment-upload',
	templateUrl: './attachment-upload.component.html',
	styleUrls: ['./attachment-upload.component.scss']
})
export class AttachmentUploadComponent implements OnInit {

	@Input() entity: string;
	@Input() eid: number;
	@Input() insideForm: boolean = false;
	@Input() title = 'Upload';
	@Input() tooltip: string;
	@Input() uploadfolder: string;
	@Input() accept: string = '';

	@Input() limitToSize: { maxwidth: number, maxheight: number, minwidth: number, minheight: number };
	@Output() uploadSuccess: EventEmitter<any> = new EventEmitter();

	filename: any;
	file: any;
	loading: boolean = false;
	progress: number;

	isImport: boolean = false;

	constructor(private attachService: AttachService,
		private messageService: MessageService,
		private dispatchService: DispatchService,
		private draftCollectionService: DraftCollectionService,
		private translateService: TranslateService,
		private deliveryService: DeliveryService,
		private activeModal: NgbActiveModal) {}

	ngOnInit() {
	}

	checkImageDimensions(width: number, height: number) {

	}

	onChange(event: any) {
		const files = event.target.files || event.dataTransfer.files;
		this.file = files && files.length ? files[0] : null;

		if (this.file && this.limitToSize) {
			const img = new Image();

			img.src = window.URL.createObjectURL(this.file);

			img.onload = () => {
				const width = img.naturalWidth,
					height = img.naturalHeight;

				if ((this.limitToSize.maxwidth && width > this.limitToSize.maxwidth) ||
					(this.limitToSize.maxheight && height > this.limitToSize.maxheight)) {
					this.reset();
					this.messageService.sendError(this.translateService.instant('labels.error-logo-size') +
						': ' + this.limitToSize.maxwidth + 'x' + this.limitToSize.maxheight);

				} else if ((this.limitToSize.minwidth && width < this.limitToSize.minwidth) ||
					(this.limitToSize.minheight && height < this.limitToSize.minheight)) {
					this.reset();
					this.messageService.sendError(this.translateService.instant('labels.error-logo-min-size') +
						': ' + this.limitToSize.minwidth + 'x' + this.limitToSize.minheight);

				} else {
					if (this.insideForm) {
						this.save();
					}
				}


			};
		} else {

			if (this.insideForm && this.file) {
				this.save();
			}
		}
	}

	reset() {
		this.filename = undefined;
		this.file = undefined;
	}

	save() {
		console.log(this.file);
		console.log(this.filename);
		if (this.isImport === true) {
			this.import();
		} else if (this.filename) {
			this.loading = true;
			let events: any;

			if (this.uploadfolder) events = this.attachService.upload(this.entity, this.eid, this.file, this.uploadfolder, this.file.name);
			else events = this.attachService.upload(this.entity, this.eid, this.file);

			events.success.subscribe(result => {
				this.loading = false;
				this.uploadSuccess.emit(result);
				if (!this.insideForm) {
					this.messageService.sendSuccess(this.translateService.instant('labels.attach-save-success'),
						this.translateService.instant('labels.attach'));
					this.activeModal.close();
				}
			});
			events.error.subscribe(({ error }) => {
				this.messageService.sendError(error, this.translateService.instant('labels.attach'));
				this.loading = false;
			});
			events.progress.subscribe(response => {
				this.progress = Math.round(response.loaded * 100 / response.total);
			});
		}
	}

	import() {
		let events;
		if (this.entity === 'dispatch') {
			events = this.dispatchService.uploadParcels(this.eid, this.file);
		} else if (this.entity === 'draftcollection')
			events = this.draftCollectionService.uploadParcels(this.eid, this.file);
		else {
			events = this.deliveryService.uploadParcels(this.eid, this.file);
		}
		events.success.subscribe(res => {
			this.messageService.sendSuccess(this.translateService.instant('labels.attach-save-success'),
				this.translateService.instant('labels.attach'));
			this.activeModal.close(res);
			this.loading = false;
		});
		events.error.subscribe(({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.attach'));
			this.loading = false;
		});
		events.progress.subscribe(response => {
			this.progress = Math.round(response.loaded * 100 / response.total);
		});
	}

	close() {
		this.activeModal.dismiss();
	}

	cancel() {
		this.activeModal.dismiss();
	}

}
